export default "__VITE_ASSET__eZOyoOgD__"